<template>
  <div
    v-if="iconName"
    class="flex size-9 items-center justify-center rounded-full text-support"
    :style="{ backgroundColor: iconColor, color: textColor }"
  >
    {{ iconName }}
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { hashString, getTextColor } from '@/lib/utils/color-utils'

const props = defineProps<{
  userName: string
}>()

const iconName = computed(() => {
  return props.userName.substring(0, 2)
})

const iconColor = computed(() => {
  if (iconName.value === '-') return `#666666`
  const hash = hashString(props.userName)
  const color = `#${(hash & 0xffffff).toString(16).padStart(6, '0')}`
  return color
})

const textColor = computed(() => getTextColor(iconColor.value))
</script>
